<script setup lang="ts">
export interface Props {
  stopCount?: number;
}
const props = withDefaults(defineProps<Props>(), {
  stopCount: 1,
});
</script>

<template>
  <div
    :class="$style.wideJobStopEmptyDiagram"
    data-testid="wideJobStopEmptyDiagram"
  >
    <div :class="$style.stops">
      <div :class="$style.road"></div>
      <div
        v-for="stopNum in props.stopCount"
        :key="stopNum"
        :class="$style.stop"
      >
        <div :class="$style.markerWrapper">
          <v-icon :class="$style.markerIcon" icon="mdi-map-marker"></v-icon>
        </div>
      </div>
    </div>
  </div>
</template>

<!-- prettier-ignore -->
<style module lang="scss">
@use '@/styles/colors';

.wideJobStopDiagram {
  line-height: 1.4;
}
  .stops {
    display: flex;
    position: relative;
    z-index: 0;
  }
    .road {
      height: 1px;
      background-color: colors.$color-text-tertiary;
      width: 100%;
      position: absolute;
      z-index: -1;
      margin-top: 17px;
    }
    .stop {
      width: 100%;
    }
      .markerWrapper {
        background-color: colors.$color-white;
        border: 3px solid colors.$color-text-tertiary;
        color: colors.$color-text-tertiary;
        width: 34px;
        height: 34px;
        font-size: 14px;
        border-radius: 50%;
        display: flex;
        align-items: center;
        justify-content: center;
      }
        .markerIcon {
          padding-top: 1px;
        }
</style>
